import React from 'react';

/**
 * Modern, consistent spinner component for the entire application
 * @param {Object} props
 * @param {string} props.size - 'sm' | 'md' | 'lg' (default: 'md')
 * @param {string} props.color - Spinner color (default: '#4DD5B8')
 * @param {boolean} props.overlay - Show as full-screen overlay (default: false)
 * @param {string} props.text - Optional text to display below spinner
 * @param {string} props.className - Additional CSS classes
 */
const Spinner = ({ 
  size = 'md', 
  color = '#4DD5B8', 
  overlay = false, 
  text = null,
  className = '' 
}) => {
  const sizeMap = {
    sm: { width: '20px', height: '20px', borderWidth: '2px' },
    md: { width: '40px', height: '40px', borderWidth: '3px' },
    lg: { width: '60px', height: '60px', borderWidth: '4px' }
  };

  const spinnerSize = sizeMap[size] || sizeMap.md;

  const spinnerStyle = {
    width: spinnerSize.width,
    height: spinnerSize.height,
    border: `${spinnerSize.borderWidth} solid rgba(77, 213, 184, 0.2)`,
    borderTop: `${spinnerSize.borderWidth} solid ${color}`,
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
    display: 'inline-block'
  };

  const containerStyle = overlay ? {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
  } : {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px'
  };

  return (
    <>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div style={containerStyle} className={className}>
        <div style={spinnerStyle} role="status" aria-label="Loading">
          <span className="visually-hidden">Loading...</span>
        </div>
        {text && (
          <p style={{ 
            margin: 0, 
            color: overlay ? '#ffffff' : '#6c757d',
            fontSize: size === 'sm' ? '12px' : size === 'lg' ? '16px' : '14px',
            fontWeight: '500'
          }}>
            {text}
          </p>
        )}
      </div>
    </>
  );
};

export default Spinner;

